// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WN3G","content":"styles_content__6DCg7"};